import React  from 'react';
import {inject, observer} from "mobx-react";
import CommonDialog from "./CommonDialog";
import {DIALOG_TYPES} from "../../common/enums/DialogTypes";
import StepDaySelectionContent from "../../views/contents/components/excel/ExcelUploadByStepAndDay";
import LoadingBar from "../loadings/LoadingBar";
import ErrorDialog from "./ErrorDialog";

function DialogGroup(props) {
    const {dialog,errorDialog,dialogStatus} = props.dialogStore;

    const getDialogContentByType = (type) => {
        const {EXCEL_UPLOAD_PART,EXCEL_UPLOAD_ALL} = DIALOG_TYPES;
        switch (type) {
            case EXCEL_UPLOAD_PART : return <StepDaySelectionContent/>;
            case EXCEL_UPLOAD_ALL : return <LoadingBar
                currentUploadCount = {props.excelStore.currentUploadCount}
                totalUploadCount = {props.excelStore.totalUploadCount}
                actionWhenComplete ={props.excelStore.displayExcelUploadErrorResult}
            />
            default: return null
        }
    }


    return (
        <>
            {dialogStatus &&
                <CommonDialog
                    contents={dialog.contentType && getDialogContentByType(dialog.contentType)}
                    controlBtnText={dialog.controlBtnText}
                    disabledButton={dialog.disabledButton}
                    clickButton={dialog.clickButton}
                    dialogClose={dialog.dialogClose}
                    controlBtn={dialog.controlBtn}
                    titleText={dialog.titleText}
                    dialogOpen={dialogStatus}
                    text={dialog.text}
                />
            }
            {errorDialog.dialogOpen &&
                <ErrorDialog
                    dialogClose={errorDialog.dialogClose}
                    dialogOpen={errorDialog.dialogOpen}
                    titleText={errorDialog.titleText}
                    text={errorDialog.text}
                />
            }
        </>
    )

}

export default inject('excelStore', 'dialogStore')(
    observer(DialogGroup)
);
